var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "popup_wrap",
      staticStyle: { width: "800px", height: "520px" },
    },
    [
      _c(
        "button",
        {
          staticClass: "layer_close",
          on: {
            click: function ($event) {
              return _vm.popClose()
            },
          },
        },
        [_vm._v(" close ")]
      ),
      _c("div", { staticClass: "popup_cont" }, [
        _c("h1", { staticClass: "page_title" }, [
          _vm._v(" " + _vm._s(_vm.$t("msg.SETT070G010.014")) + " "),
        ]),
        _c(
          "div",
          { staticClass: "content_box" },
          [
            _c("p", { staticClass: "color_red" }, [
              _vm._v("* " + _vm._s(_vm.$t("msg.SETT070G010.037"))),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "color_red mb10" }, [
              _vm._v("* " + _vm._s(_vm.$t("msg.SETT070G010.038"))),
            ]),
            _vm._v(" "),
            _c("DEXT5Upload", {
              ref: "dextupload_mr",
              attrs: {
                id: _vm.component_id,
                width: "100%",
                height: "200px",
                category: false,
                single: _vm.singleFileYn,
                "file-info": _vm.parentInfo,
                "is-show-pop": _vm.isShowPop,
                "category-info": [],
                "kind-detail": "",
                "detail-info": _vm.detailList,
                "eor-ext": _vm.eorExt,
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "mt10 text_center" }, [
        _c(
          "a",
          {
            staticClass: "button blue lg",
            on: {
              click: function ($event) {
                return _vm.popClose()
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("msg.SETT070G010.015")))]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }